import appointment from 'assets/icons/appointment.svg';
import results from 'assets/icons/results.svg';
import journey from 'assets/icons/journey.svg';
import messages from 'assets/icons/messages.svg';

export const menuItems = [
  {
    id: 'appointment',
    label: 'Appointments',
    icon: appointment,
    to: "/appointments"
  },
  {
    id: 'results',
    label: 'Results',
    icon: results,
    to: "/results"
  },
  {
    id: 'journey',
    label: 'My Journey',
    icon: journey,
    to: "/myjourney"
  },
  {
    id: 'messages',
    label: 'Messages',
    icon: messages,
    to: "/messages"
  }
];

export const secondaryItems = [
  {
    id: 'billing',
    label: 'Billing',
    to: "/billing"
  },
  {
    id: 'documents',
    label: 'Documents',
    to: "/documents"
  },
  {
    id: 'settings',
    label: 'Settings',
    to: "/settings"
  },
  {
    id: 'logout',
    label: 'Log out',
    to: "/login"
  },
];



// WEBPACK FOOTER //
// ./src/components/Navigation/menuItems.js